import React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GET_COACHING_USER_STRIPE_SOURCE from 'coaching/queries/GetUserStripeSource.gql';
import {
  GetUserStripeSource,
  GetUserStripeSourceVariables,
  GetUserStripeSource_getUserStripeSource_creditCard,
} from 'coaching/queries/__generated__/GetUserStripeSource';

export type Props = {
  children: (props: {
    creditCard?: GetUserStripeSource_getUserStripeSource_creditCard | null;
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetCoachingUserStripeSourceContainer(props: Props) {
  return (
    <Query<GetUserStripeSource, GetUserStripeSourceVariables>
      query={GET_COACHING_USER_STRIPE_SOURCE}
      variables={{ stripeAccountName: 'coaching' }}>
      {({ loading, error, data }) => {
        return props.children({
          creditCard: data?.getUserStripeSource?.creditCard,
          loading,
          error,
        });
      }}
    </Query>
  );
}
